import { Component, EventEmitter, OnInit, Input, Output, ViewChild, VERSION } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, Subscription, tap } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { dashboardRouteWithSlash } from 'src/app/route-constants';

@Component({
  selector: 'pgh-additional-device-questionnaire',
  templateUrl: './additional-device-questionnaire.component.html',
  styleUrls: ['./additional-device-questionnaire.component.scss']
})
export class AdditionalDeviceQuestionnaireComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() public preSelectedDevice?: PghUserDeviceBase;

  programCode: string;
  hylaLink: string;

  private subscriptions: Subscription[] = [];

  public elementType:NgxQrcodeElementTypes;
  public value:string;
  public correctionLevel:NgxQrcodeErrorCorrectionLevels;

  public additionalDeviceQuestionnaireForm: UntypedFormGroup;

  constructor(
    public resourceService: ADPResourceService,
    private utilityServce: UtilityService,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
    private dialog: MatDialog,
    private router: Router,
  ) { }


  ngOnInit(): void {

    this.additionalDeviceQuestionnaireForm = new FormGroup({
      selectedAnswer: new FormControl('', Validators.required)
    });

  }

  public handleNextEvent() {

    const selectedAnswer = [this.additionalDeviceQuestionnaireForm.get('selectedAnswer').value];

    if (this.additionalDeviceQuestionnaireForm.valid)
     {
      let data:any[] = [];
      data.push([]);

      if(selectedAnswer[0] === 'YES'){
        data[0].addDevice = true;
        this.nextEvent.emit(data);
      }
      else if(selectedAnswer[0] === 'NO'){
        data[0].addDevice = false;

        let dialogData: ConfirmationDialogData;

        dialogData = {
            title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
            message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
            cancelButtonText: "Global_Button_SkipForNow",
            confirmButtonText: "Global_Button_ContinueTest",
            contextData: { titleLeftAligned: false }
          };

        const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
          data: dialogData
        });
        this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
          next: (result) => {
            if (result.toString() === 'false') {
              this.router.navigate([dashboardRouteWithSlash]);
            }
          }
        }));

      }
    }
  }

  goHome(): void {
    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }

  addAnotherDevice(): void{

    let data:any[] = [];
    data.push([]);
    data[0].addDevice = true;
    this.nextEvent.emit(data);

    //this.router.navigate(['additional-device-selection'],{ queryParams: { isOnboardingFlow: 'true', isAdditionalDeviceFlow: 'true'}});
  }


}
